module.exports = __webpack_public_path__ + "img/tick-double.92d68fc2.svg";